import {ScrollTrigger} from 'gsap/ScrollTrigger';
import {TextPlugin} from 'gsap/TextPlugin';
import helpers from '../helpers';
import moreArcAnim from './more-arc';

gsap.registerPlugin(ScrollTrigger, TextPlugin);

export function articleAnimation() {
	const $article = $('.article:not(.is-old)');

	const $articleElement = $article.find('.article-1__intro-element');
	const $articleDecoreOne = $articleElement.find('.article-1__intro-decore--1');
	const $articleDecoreTwo = $articleElement.find('.article-1__intro-decore--2');
	const $articleDecoreThree = $articleElement.find('.article-1__intro-decore--3');

	const $articleQuoteElement = $article.find('.article-1__quote-element');
	const $articleQuoteDecoreOne = $articleQuoteElement.find('.article-1__quote-decore--1');
	const $articleQuoteDecoreTwo = $articleQuoteElement.find('.article-1__quote-decore--2');
	const $articleQuoteDecoreThree = $articleQuoteElement.find('.article-1__quote-decore--3');
	const $articleQuoteDecoreFour = $articleQuoteElement.find('.article-1__quote-decore--4');

	const $articlePeoplesElement = $article.find('.article-1__peoples-element');
	const $articlePeoplesDecoreOne = $articlePeoplesElement.find('.article-1__peoples-decore--1');
	const $articlePeoplesDecoreTwo = $articlePeoplesElement.find('.article-1__peoples-decore--2');
	const $articlePeoplesDecoreThree = $articlePeoplesElement.find('.article-1__peoples-decore--3');
	const $articlePeoplesDecoreFour = $articlePeoplesElement.find('.article-1__peoples-decore--4');

	const $articleTextElement = $article.find('.article-1__text-element');
	const $articleTextDecoreOne = $articleTextElement.find('.article-1__text-decore--1');
	const $articleTextDecoreTwo = $articleTextElement.find('.article-1__text-decore--2');
	const $articleTextDecoreThree = $articleTextElement.find('.article-1__text-decore--3');

	const $articleTextBlockElement = $article.find('.article-1__text-block-element');
	const $articleTextBlockDecoreOne = $articleTextBlockElement.find('.article-1__text-block-decore--1');
	const $articleTextBlockDecoreTwo = $articleTextBlockElement.find('.article-1__text-block-decore--2');
	const $articleTextBlockDecoreThree = $articleTextBlockElement.find('.article-1__text-block-decore--3');
	const $articleTextBlockDecoreFour = $articleTextBlockElement.find('.article-1__text-block-decore--4');

	const $articleInsertionElement = $article.find('.article-1__insertion-element');
	const $articleInsertionDecoreOne = $articleInsertionElement.find('.article-1__insertion-decore--1');
	const $articleInsertionDecoreTwo = $articleInsertionElement.find('.article-1__insertion-decore--2');
	const $articleInsertionDecoreThree = $articleInsertionElement.find('.article-1__insertion-decore--3');
	const $articleInsertionDecoreFour = $articleInsertionElement.find('.article-1__insertion-decore--4');

	const $peoples = $article.find('.article-1__peoples');
	const $people = $article.find('.article-1__people');
	const $peopleName = $people.find('.article-1__people-name');
	const $peopleDesc = $people.find('.article-1__people-description');
	const $verticalDividerOne = $article.find('.article-1__vertical-divider-line--1');
	const $verticalDividerTwo = $article.find('.article-1__vertical-divider-line--2');
	const $articleMoreLine = $article.find('.article__more-line-inner');
	const $articleMoreItem = $article.find('.article__more-content-item');

	$('.aos-animate').removeClass('aos-animate');

	AOS.refresh();

	setTimeout(() => {
		AOS.init({
			once: true,
			delay: 50,
			offset: 150,
			duration: 500,
			disable: helpers.isMobile(),
		});
	}, 300);

	if (!helpers.isMobile()) {
		gsap.from($articleDecoreOne, {
			scale: 0,
			autoAlpha: 0,
			delay: 1.3,
		});

		gsap.from($articleDecoreTwo, {
			x: -100,
			y: 100,
			autoAlpha: 0,
			delay: 1.3,
		});

		gsap.from($articleDecoreThree, {
			x: 100,
			y: -100,
			autoAlpha: 0,
			delay: 1.3,
		});

		gsap.from($articleQuoteElement, {
			scrollTrigger: {
				trigger: $articleQuoteElement,
			},
			autoAlpha: 0,
			onStart: () => {
				gsap.from($articleQuoteDecoreOne, {
					x: -200,
					y: 200,
					autoAlpha: 0,
				});

				gsap.from($articleQuoteDecoreTwo, {
					scale: 0,
					autoAlpha: 0,
				});

				gsap.from($articleQuoteDecoreThree, {
					x: 100,
					y: -200,
					autoAlpha: 0,
				});

				gsap.from($articleQuoteDecoreFour, {
					scale: 0,
					autoAlpha: 0,
				});
			},
		});

		gsap.from($articlePeoplesElement, {
			scrollTrigger: {
				trigger: $articlePeoplesElement,
			},
			autoAlpha: 0,
			onStart: () => {
				gsap.from($articlePeoplesDecoreOne, {
					x: 200,
					y: -200,
					autoAlpha: 0,
				});

				gsap.from($articlePeoplesDecoreTwo, {
					scale: 0,
					autoAlpha: 0,
				});

				gsap.from($articlePeoplesDecoreThree, {
					x: 100,
					y: -200,
					autoAlpha: 0,
				});

				gsap.from($articlePeoplesDecoreFour, {
					x: -200,
					y: 200,
					autoAlpha: 0,
				});
			},
		});

		gsap.from($articleTextElement, {
			scrollTrigger: {
				trigger: $articleTextElement,
			},
			autoAlpha: 0,
			onStart: () => {
				gsap.from($articleTextDecoreOne, {
					x: 400,
					y: -400,
					autoAlpha: 0,
				});

				gsap.from($articleTextDecoreTwo, {
					scale: 0,
					autoAlpha: 0,
				});

				gsap.from($articleTextDecoreThree, {
					x: -400,
					y: 400,
					autoAlpha: 0,
				});
			},
		});

		gsap.from($articleTextBlockElement, {
			scrollTrigger: {
				trigger: $articleTextBlockElement,
			},
			autoAlpha: 0,
			onStart: () => {
				gsap.from($articleTextBlockDecoreOne, {
					x: 400,
					y: -400,
					autoAlpha: 0,
				});

				gsap.from($articleTextBlockDecoreTwo, {
					scale: 0,
					autoAlpha: 0,
				});

				gsap.from($articleTextBlockDecoreThree, {
					x: -400,
					y: 400,
					autoAlpha: 0,
				});

				gsap.from($articleTextBlockDecoreFour, {
					x: 200,
					y: -200,
					autoAlpha: 0,
				});
			},
		});

		gsap.from($articleInsertionElement, {
			scrollTrigger: {
				trigger: $articleInsertionElement,
			},
			autoAlpha: 0,
			onStart: () => {
				gsap.from($articleInsertionDecoreOne, {
					x: 400,
					y: -400,
					autoAlpha: 0,
				});

				gsap.from($articleInsertionDecoreTwo, {
					scale: 0,
					autoAlpha: 0,
				});

				gsap.from($articleInsertionDecoreThree, {
					x: -400,
					y: 400,
					autoAlpha: 0,
				});

				gsap.from($articleInsertionDecoreFour, {
					x: -200,
					y: 200,
					autoAlpha: 0,
				});
			},
		});

		gsap.set([$verticalDividerOne, $verticalDividerTwo, $articleMoreLine], {
			height: 0,
		});

		gsap.from($peopleName, {
			scrollTrigger: {
				trigger: $peopleName,
				start: 'top 100%-=200px',
			},
			onStart: () => {
				$peopleName.addClass('is-active');
			},
		});

		gsap.from($peoples, {
			scrollTrigger: {
				trigger: $peoples,
				start: 'top 100%-=200px',
			},
			autoAlpha: 0,
			onStart: () => {
				gsap.from($peopleDesc, {
					autoAlpha: 0,
					y: -100,
				});
				gsap.to($verticalDividerOne, {
					delay: 0.5,
					duration: 0.75,
					height: '100%',
				});
			},
		});

		gsap.from($verticalDividerTwo, {
			scrollTrigger: {
				trigger: $verticalDividerTwo,
				start: 'top 100%-=200px',
			},
			autoAlpha: 0,
			onStart: () => {
				gsap.to($verticalDividerTwo, {
					duration: 0.75,
					height: '100%',
				});
			},
		});
	}

	moreArcAnim.init($article);

	// Смотрим кукисы с записью о урле
	// Если нет записей, то добавляем первую
	if (!helpers.getCookie('articleMore')) {
		helpers.setCookie('articleMore', window.location.pathname, 7);
	} else {
		const getCookie = helpers.getCookie('articleMore').split(', ');

		for (let i = 0; i < getCookie.length; i++) {
			const element = getCookie[i];

			// Если текущий урл ещё не был записан, то добавляем
			if (element !== window.location.pathname) {
				helpers.setCookie('articleMore', `${helpers.getCookie('articleMore')}, ${window.location.pathname}`, 7);
			}

			$articleMoreItem.each((j, el) => {
				const url = $(el).attr('href');

				if (url === element) {
					$(el).css({
						order: 10 + j,
					});
				}
			});
		}
	}

	$('.article-1__people-name').on('click', (e) => {
		e.preventDefault();

		const id = $(e.currentTarget).attr('href');

		helpers.scrollTo($(id));
	});
}
